import { render, staticRenderFns } from "./ReservationChip.vue?vue&type=template&id=6818b118"
import script from "./ReservationChip.vue?vue&type=script&lang=js"
export * from "./ReservationChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports